import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Dispatch } from 'redux';
import { Loader } from 'semantic-ui-react';

import { createUserList, getTagList, getUserTags, optionsUserTags, updateUserList } from '../../actions/AlphaListsActions';
import { addFlashMessages, removeFlashLocations } from '../../actions/FlashMessagesActions';
import { localeData } from '../../locales/data';
import { StateType } from '../../reducers';
import {
  alphaListCurrentListSelector,
  alphaListFetchingDataSelector,
  alphaListFetchingTagDataSelector,
  alphaListFetchingUpdateListSelector,
  alphaListUserListOptionsSelector,
} from '../../reducers/AlphaListsReducer/AlphaListsSelector';
import { logErrorService } from '../../shared/services';
import { DispatchConnect } from '../../types/';

import { AlphasAddToListPropsGeneric, AlphasAddToListState, AlphasAddToListStateDispatchers, AlphasAddToListStateProps } from './types';
import './AlphasAddToList.scss';
import { AlphasAddToListMain } from './AlphasAddToListMain';

interface DinamicallyState {
  name: 'newList' | 'list';
  value: any;
}

class AlphasAddToList extends React.Component<AlphasAddToListPropsGeneric, AlphasAddToListState> {
  public state: AlphasAddToListState = { newList: '', list: '' };

  UNSAFE_componentWillMount() {
    this.props.dispatchOptionsUserTags();
    if (!this.props.alphaLists || (this.props.alphaLists.size === 0 && this.props.fetchingTags === false)) {
      this.props.dispatchGetUserTags().catch((err: any) => {
        logErrorService(err, err);
      });
    }
  }

  componentWillUnmount() {
    this.props.dispatchRemoveFlashLocations();
  }

  handleChangeAddToList = (e: any, data: DinamicallyState) => {
    e.preventDefault();
    const name: 'newList' | 'list' = data.name;
    const value: any = data.value;
    if (data) {
      this.setState({
        [name]: value,
      } as Pick<AlphasAddToListState, keyof AlphasAddToListState>);
    }
  };

  handleAddAlphaToList = (listName: string, newList: boolean, redirect: boolean, alpha?: string) => {
    if (newList) {
      this.createAndAddToList(listName, alpha, redirect);
    } else {
      this.addToList(listName, alpha, redirect);
    }
  };

  addToList(listName: string, alpha: string | undefined, redirect: boolean) {
    if (!listName || listName.length < 1) {
      return;
    }
    const list = this.props.alphaLists.toJS().find((val: any) => val.name === listName);
    const id = list.id;
    this.props
      .dispatchGetTagList(id)
      .then(() => {
        let addAlpha = false;
        if (alpha && this.props.currentAlphaList) {
          addAlpha = this.props.currentAlphaList.get('alphas').filter((val: any) => val.id === alpha).length <= 0;
        } else {
          if (this.props.alphas && this.props.currentAlphaList) {
            const alphasAvailable = this.props.alphas.filter(
              (r: any) =>
                this.props.currentAlphaList
                  .get('alphas')
                  .toJS()
                  .some((x: any) => x.id === r) === false
            );

            addAlpha = alphasAvailable.length > 0;
          } else {
            this.props.dispatchErrorMessage('invalid.alphaList');
          }
        }

        if (addAlpha) {
          this.setState({ list: '' }, async () =>
            this.props.dispatchUpdateUserList(id, listName, this.props.alphas).then(() => {
              if (redirect) {
                const listId = this.props.alphaLists.toJS().find((val: any) => val.name === listName).id;
                this.props.history.push(`/alphas/${listId}`);
              }
              this.props.handleCloseModal();
            })
          );
        } else {
          if (redirect) {
            const listId = this.props.alphaLists.toJS().find((val: any) => val.name === listName).id;
            this.props.history.push(`/alphas/${listId}`);
          }
          this.props.handleCloseModal();
        }
      })
      .catch((err: any) => {
        logErrorService(err, err);
      });
  }

  createAndAddToList(listName: string, alpha: string | undefined, redirect: boolean) {
    if (!listName || listName.length < 1) {
      return;
    }
    if (this.props.alphaLists.toJS().filter((val: any) => val.name === listName).length > 0) {
      this.props.dispatchErrorMessage('alphaList.already.exists.msg');
    } else {
      const alphas = alpha ? [alpha] : this.props.alphas;
      this.setState({ newList: '' }, async () =>
        this.props.dispatchCreateUserList(listName, alphas).then(() => {
          if (redirect) {
            const listId = this.props.alphaLists.toJS().find((val: any) => val.name === listName).id;
            this.props.history.push(`/alphas/${listId}`);
          }
          this.props.handleCloseModal();
        })
      );
    }
  }

  render() {
    return this.props.fetchingTags || this.props.fetchingTagAlpha || this.props.fetchingUpdateList ? (
      <div className="loader alphaAdd__content">
        <Loader active={true} inline="centered" size="massive" />
      </div>
    ) : (
      <AlphasAddToListMain
        list={this.state.list}
        userLists={this.props.alphaLists}
        alphas={this.props.alphas}
        fetching={this.props.fetchingTags || this.props.fetchingTagAlpha || this.props.fetchingUpdateList}
        handleChange={this.handleChangeAddToList}
        handleAddToList={this.handleAddAlphaToList}
        hideAddToList={this.props.hideAddToList || false}
        hideNewlist={this.props.hideNewlist || false}
      />
    );
  }
}

const mapStateToProps = (state: StateType): AlphasAddToListStateProps => ({
  alphaLists: alphaListUserListOptionsSelector(state),
  currentAlphaList: alphaListCurrentListSelector(state),
  // @ts-ignore
  fetchingTags: alphaListFetchingDataSelector(state),
  // @ts-ignore
  fetchingTagAlpha: alphaListFetchingTagDataSelector(state),
  // @ts-ignore
  fetchingUpdateList: alphaListFetchingUpdateListSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<any>): AlphasAddToListStateDispatchers => ({
  dispatchGetUserTags: async () => dispatch(getUserTags()),

  dispatchGetTagList: async (id: string) => dispatch(getTagList(id)),

  dispatchRemoveFlashLocations: async () => dispatch(removeFlashLocations(['alpha-list'])),

  dispatchErrorMessage: async (errorMessage: string) => {
    dispatch(addFlashMessages([{ msg: errorMessage, defaultMessage: localeData.en[errorMessage] }], { location: 'alpha-list' }));
    setTimeout(() => dispatch(removeFlashLocations(['alpha-list'])), 3000);
  },

  dispatchCreateUserList: async (listName: string, alphas: string[]) => dispatch(createUserList(listName, alphas)),

  dispatchUpdateUserList: async (tagId: string, listName: string, alphas: string[]) =>
    dispatch(updateUserList(tagId, listName, alphas, 'add')),

  dispatchOptionsUserTags: async () => dispatch(optionsUserTags()),
});

export default withRouter(
  connect<AlphasAddToListStateProps, DispatchConnect<AlphasAddToListStateDispatchers>, any, StateType>(
    mapStateToProps,
    mapDispatchToProps
  )(AlphasAddToList)
);
